import axios from 'axios';
import { getUsersQuery } from './queries';
import { buildLoopbackQuery } from './queries/builders';

const getUsersByIds = (ids, fields, queryBuilder = buildLoopbackQuery) =>
    new Promise((resolve, reject) => {
        const userQuery = getUsersQuery({ ids, fields, queryBuilder });
        const userRequest = axios.get(userQuery);
        userRequest
            .then((userResponse) => {
                resolve(userResponse.data);
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getUsersByIds;
